<template>

    <div class="container">

        <div class="content">

            <div class="left" v-bind:style="{ backgroundImage: image_url('left') }"></div>

            <div class="items">

                <template v-if="featured.length > 0">
                
                    <featured-projects :projects="featured"></featured-projects>

                </template>


                <p class="headline other_projects">OTHER PROJECTS</p>

                <div class="other__projects">

                    <div class="project" v-for="other_project, index in projects" @click="toProject(other_project.slug)" v-bind:key="index">
                    
                        <div class="wrapper">

                            <div class="feat_img"
                                v-bind:style="{
                                    background: get_background_image(other_project),
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    backgroundColor: 'black',
                                    backgroundPosition: 'center 80%'
                                }"
                            ></div>

                            <a class="span_action" :href="'/projects/' + other_project.slug"><p>See details</p></a>

                            <div class="project_name">
                                <p>{{ other_project.name }}</p>
                            </div>


                        </div>

                    </div>

                </div>


            </div>

            <div class="right" v-bind:style="{ backgroundImage: image_url('right') }"></div>

        </div>

    </div>

</template>
<script>
    export default {
        data(){
            return {
                text: "Vue3 component."
            }
        },
        props: ['projects', 'featured', 'left_image', 'right_image'],
        methods: {
            get_background_image(project){
                return "url('" + '/image/' + project.media_path + '/' + project.featured_image + "')"
            },
            toProject(slug){
                if(window.innerWidth < 837){
                    window.location.href = '/projects/' + slug;
                }
            },
            image_url(position){
                if(position === 'left') return "url('" + this.left_image.media_URL + "')"
                if(position === 'right') return "url('" + this.right_image.media_URL + "')"
            }
        }
    }
</script>
<style lang="scss" scoped>

    .content{

        display: flex;
        flex-direction: row;
        width: 100%;
        max-width: 1920px;
        margin: auto;

        .left{
            display: block;
            min-width: 168px;
            // height: 100vh;
            min-height: 100%;

            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            // img{
            //     display: block;
            //     width: 100%;
            //     height: auto;
            // }
        }

        .items{
            display: flex;
            flex-direction: column;
            background: linear-gradient(180deg, #2A1542 0%, #000000 100%);
            padding: 75px 112px;
            width: 100%;

            .headline{
                font-family: 'DIN Next LT Pro Bold';
                font-style: normal;
                // font-weight: 700;
                font-size: 30px;
                line-height: 36px;

                color: #FFFFFF;
                margin: 0;
            }                

            .other__projects{
                display: flex;
                flex-direction: row;
                justify-content: center;
                max-width: 1300px;
                flex-wrap: wrap;
                margin: 0 auto;
                margin-top: 94px;


                .project{
                    width: 300px;
                    height: 236px;

                    .wrapper{
                        display: block;
                        position: relative;
                        width: 100%;
                        height: 100%;
                        overflow: hidden;

                        .feat_img{
                            display: block;
                            width: 100%;
                            height: 100%;
                        }

                        .project_name{
                            border: 10px solid;
                            border-image-slice: 1;
                            border-width: 2px 0 0 0;
                            border-image-source: linear-gradient(90deg, #ED1163 1.33%, #5C2C90 98.83%);
                            position: absolute;
                            bottom: 0;
                            width: 100%;
                            background: rgba(0, 0, 0, 0.5);
                            height: 30px;

                            p{
                                font-family: 'DIN Next LT Pro Bold';
                                font-style: normal;
                                // font-weight: 700;
                                font-size: 14px;
                                line-height: 17px;
                                /* identical to box height */

                                color: #FFFFFF;
                                margin: 7px auto;
                                text-align: center;
                                text-transform: uppercase;
                            }
                        }

                        .span_action{
                            // background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                            background: rgba($color: #ED1163, $alpha: 0.5);
                            height: 100%;
                            width: 100%;
                            transition: all .3s ease-in-out;
                            margin-top: auto;
                            margin-bottom: 0;
                            opacity: 0;

                            position: absolute;
                            bottom: 30px;
                            transform: translateY(100%);

                            text-decoration: none;

                            p{
                                font-family: "DIN Next LT Pro Bold";
                                font-style: normal;
                                font-size: 14px;
                                line-height: 17px;
                                color: #FFFFFF;
                                // margin: 7px auto;
                                text-align: center;
                                text-transform: uppercase;

                                position: absolute;
                                top: 55%;
                                right: 51%;
                                transform: translate(50%,-50%);

                                transition: all .3s ease-in-out;

                                opacity: 0;
                            }
                        }

                        &:hover{
                            .span_action{
                                transform: translateY(0%);
                                opacity: 1;

                                p{
                                    opacity: 1;
                                }
                            }
                        }
                        

                    }
                }


            }
        }

        .right{
            display: block;
            min-width: 168px;
            // background: #000000;
            min-height: 100%;

            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            // img{
            //     display: block;
            //     width: 100%;
            //     height: auto;
            // }
        }
    }


    @media screen and (max-width: 836px) {

        .container{

            .intro{
                
                .overlay{

                    .wrapper{
                        width: 100%;

                        .subline{
                            font-size: 20px;
                            line-height: 24px;
                            text-align: center;
                            margin-bottom: 15px;
                        }

                        .headline{
                            font-size: 40px;
                            line-height: 40px;
                            text-align: center;
                        }

                        .keywords{
                            font-size: 16px;
                            line-height: 16px;
                        }

                        a.anim_button{
                            width: 100%;
                            max-width: 245px;
                            height: 35px;
                            
                            p{
                                font-size: 12px;
                                line-height: 40px;
                            }
                        }
                    }

                    .bottom__bar{
                        .text-wrap{
                            .red_text, .regular_text, .red_text.second{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-size: 18px;
                                line-height: 25px;
                            }   
                        }
                    }
                }
            }
        }

        .content{
            .left, .right{
                display: none;
            }

            .items{
                padding: 75px 0;
                width: 100%;

                .headline{
                    margin: 0 12px;
                    text-align: center;
                    font-size: 22px;
                    line-height: 26px;
                }

                .other__projects{
                    .project{
                        .wrapper:hover{
                            .span_action{
                                opacity: 0;
                                transform: translateY(100%);
                            }
                        }
                    }
                }
            }
        }

    }
        
    


</style>